import { MORETON_BAY_SLUGS } from "@/lib/moreton-bay";

/** Suburbs that have their own top-level Sunshine Coast landing page. */
const COAST_SLUGS = [
  "aroona",
  "baringa",
  "battery-hill",
  "buderim",
  "caloundra",
  "currimundi",
  "dicky-beach",
  "golden-beach",
  "kings-beach",
  "little-mountain",
  "maroochydore",
  "meridan-plains",
  "mooloolaba",
  "noosa",
  "moffat-beach",
  "pelican-waters",
  "shelly-beach",
  "wurtulla",
];

export function suburbSlug(name: string) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

/**
 * Returns the internal path for a suburb name when we have a page for it,
 * otherwise null. Used to cross-link nearby-area lists.
 */
export function suburbHref(name: string, currentSlug?: string): string | null {
  const slug = suburbSlug(name);
  if (slug === currentSlug) return null;
  if (COAST_SLUGS.includes(slug)) return `/${slug}`;
  if (MORETON_BAY_SLUGS.includes(slug)) return `/moreton-bay/${slug}`;
  return null;
}
